export const CANONICAL_PAYMENT_SEARCH_PATH = '/payez-un-avis';
export const PUBLIC_TICKET_SEARCH_PATHS = [
    '/recherche',
    CANONICAL_PAYMENT_SEARCH_PATH,
    '/payer-un-avis',
    '/tickets',
];
export const TICKET_SEARCH_PARAM = 'avis';
export const TICKET_SEARCH_PARAM_ALIASES = ['avis', 'ticket', 'ticketId', 'id'];
export const MAX_TICKET_SEARCH_LENGTH = 9;

export const normalizeTicketSearchValue = (value = '') =>
    String(value).trim().replace(/\s+/g, '');

export const isValidTicketSearchValue = (value) => {
    const normalizedValue = normalizeTicketSearchValue(value);
    return normalizedValue !== ''
        && normalizedValue.length <= MAX_TICKET_SEARCH_LENGTH
        && /^[0-9]+$/i.test(normalizedValue);
};

export const getTicketSearchParam = (search = '') => {
    const params = new URLSearchParams(search);

    for (const paramName of TICKET_SEARCH_PARAM_ALIASES) {
        const paramValue = params.get(paramName);

        if (paramValue !== null) {
            return normalizeTicketSearchValue(paramValue);
        }
    }

    return '';
};

export const buildTicketSearchUrl = (ticketNumber) =>
    `${CANONICAL_PAYMENT_SEARCH_PATH}?${TICKET_SEARCH_PARAM}=${encodeURIComponent(normalizeTicketSearchValue(ticketNumber))}`;
